import { render, staticRenderFns } from "./WaterLoss.vue?vue&type=template&id=176fafda&scoped=true&"
import script from "./WaterLoss.vue?vue&type=script&lang=js&"
export * from "./WaterLoss.vue?vue&type=script&lang=js&"
import style0 from "./WaterLoss.vue?vue&type=style&index=0&id=176fafda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fafda",
  null
  
)

export default component.exports